import { Box, styled, themeGet } from '@qwealth/qcore';

export const StyledConversationMessageBox = styled(Box)`
  margin-bottom: ${themeGet('space.large')};
  display: grid;
  grid-template-columns: auto 5fr 1fr;
  width: 100%;
  column-gap: ${themeGet('space.large')};
  row-gap: ${themeGet('space.small')};
  overflow: hidden;

  .profile-icon-column {
    justify-self: center;
    grid-row: 1 / span 2;
  }

  .avatar {
    border-radius: ${themeGet('radii.round')};
    height: 40px;
    width: 40px;
    background-color: ${themeGet('colors.primary')};
    font-size: ${themeGet('fontSizes.default')};
    font-weight: ${themeGet('fontWeights.bold')};
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .username-row {
    font-weight: ${themeGet('fontWeights.bold')};
  }

  .message-row {
    overflow: hidden;
    grid-column: 2;
    align-self: center;
  }

  .date-column {
    grid-column: 3;
    grid-row: 1;
    justify-self: center;

    @media (max-width: 2350px) {
      grid-column: 2;
      grid-row: 2;
      justify-self: flex-start;
    }
  }

  .delete-button {
    grid-column: 3;
    grid-row: 2;
    justify-self: center;
  }
`;
